import type { IHelpdeskConfig, IHelpdeskLimits } from "@kuika/kuika-cl-model";
import React from "react";
import KuikaSpinner from "../../ui-kit/kuika-spinner/kuika-spinner";
import { useHelpdeskConfig } from "./helpdesk-config";

export interface HelpdeskProviderSwitchProps {
  /** Today's Zendesk helpdesk, rendered unchanged when CoreApi routes to Zendesk. */
  zendesk: React.ReactNode;
  /** The Kuika ITSM helpdesk, given the limits CoreApi reports. */
  itsm: (limits: IHelpdeskLimits) => React.ReactNode;
}

/** Renders the helpdesk CoreApi is configured for (`HELPDESK_PROVIDER`). */
const HelpdeskProviderSwitch = ({ zendesk, itsm }: HelpdeskProviderSwitchProps): React.ReactElement => {
  const config: IHelpdeskConfig | null = useHelpdeskConfig();

  if (!config) {
    return (
      <div className="kuika-flex-center kuika-width-full kuika-height-full">
        <KuikaSpinner />
      </div>
    );
  }

  return <>{config.provider === "Itsm" ? itsm(config.limits) : zendesk}</>;
};

export default HelpdeskProviderSwitch;
